const CHECKOUT_ID_KEY = "nlhsc-checkout-id";

export const checkoutStorage = {
  get: (): string | null => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(CHECKOUT_ID_KEY);
  },

  set: (id: string): void => {
    if (typeof window === "undefined") return;
    localStorage.setItem(CHECKOUT_ID_KEY, id);
  },

  clear: (): void => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(CHECKOUT_ID_KEY);
  },

  // Listen for changes across tabs
  onStorageChange: (callback: (newId: string | null) => void): (() => void) => {
    if (typeof window === "undefined") return () => {};

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === CHECKOUT_ID_KEY) {
        callback(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Return cleanup function
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  },
};
